module.exports = __webpack_public_path__ + "static/media/Festival3.2775e471.png";